<script setup lang="ts">
import { computed } from 'vue';
import type { KpiDto } from '@/api/reports';
import StatCard from '@/components/ui/StatCard.vue';

interface Props {
  kpis: KpiDto;
}

const props = defineProps<Props>();

function formatDelta(pct: number): string {
  if (Math.abs(pct) < 0.5) return '—';
  return pct > 0 ? `▲ ${pct.toFixed(0)}%` : `▼ ${Math.abs(pct).toFixed(0)}%`;
}

const totalSub = computed(() => {
  const delta = formatDelta(props.kpis.issuesVsPriorMonthPct);
  return delta === '—' ? 'vs prior month' : `${delta} vs prior month`;
});
</script>

<template>
  <div
    class="grid grid-cols-2 sm:grid-cols-4 gap-4"
    data-testid="report-kpi-grid"
  >
    <StatCard
      label="Issues"
      :value="kpis.issuesTotal"
      :sub="totalSub"
    />
    <StatCard
      label="Resolved"
      :value="kpis.issuesResolved"
    />
    <StatCard
      label="Within SLA"
      :value="`${kpis.resolvedOnTimePct.toFixed(0)}%`"
    />
    <StatCard
      label="Avg Resolution"
      :value="kpis.avgResolutionDisplay"
    />
  </div>
</template>
